export enum Roles {
  SUPERUSER = "superuser",
  USER = "user",
  BACKOFFICE = "backoffice",
  DTA = "dta",
  MCP = "mcp",
  CHAT = "chat",
  APIKEYS = "apikeys",
  TFS = "tfs",
  SONARADMIN = "sonaradmin",
  MCP_REPORTS = "mcp:reports",
}
